import React, { useRef, useState } from "react";

import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  TableBody,
  TextField,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import dayjs from "dayjs";
import { ThreeCircles } from "react-loader-spinner";

import SideNav from "component/layouts/sideNav";
import { setAlertTitleText } from "component/modal/alertModal";
import {
  getInvoices,
  getItemCategories,
  getItemList,
  getOrders,
  getSiteCategories,
  getSites,
  getSupplierCategories,
  getSuppliers,
  getUoms,
  globalFilter,
  setInvoices,
  setOrders,
  setSiteCategories,
  setSites,
  setUoms,
} from "component/cellRenderers/renderers";

import {
  LIGHT_GREY_BACKGROUND,
  SPANISH_GREEN,
  WHITE,
} from "resources/constant/colors/theme";
import {
  BALANCE_BILLING_REPORT,
  CUSTOMER_MANAGEMENT_REPORT,
  EXPORT,
  GENERATE,
} from "resources/constant/strings/string";
import { PATH_BALANCE_BILLING_REPORT } from "resources/constant/url/url";

import { APIMASTER } from "apihandler/master";
import { APIREPORTS } from "apihandler/reports";
import { APISALES } from "apihandler/sales";
import { APIUTILS } from "apihandler/utils";

const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  color: SPANISH_GREEN,
  transform: "translate(-50%, -50%)",
  zIndex: 2,
};

export default function BalanceBillingReport() {
  const [itemDetails, setItemDetails] = useState([]);

  const getSortedDataFromGrid = () => {
    const sortedData = [];
    gridRef1.current.api.forEachNodeAfterFilterAndSort((node) => {
      sortedData.push(node.data);
    });
    return sortedData;
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    validation();
    //
  };
  function validation() {
    setDataReady(false);
    APIREPORTS.BalanceBillingReport(dto)
      .then((response) => response.json())
      .then((data) => {
        if (data.statusCode !== 200) {
          setDataReady(true);
          setAlertTitleText("Oops..", `An error occurred ${data.message}`);
          return;
        }
        try {
          setDataReady(true);
          gridRef1.current.api.setRowData([]);
        } catch (e) {}

        data.response.itemDetails.forEach((x) => {
          const reqdItem = items.filter((y) => y.id === x.itemId);
          x.itemCategoryId =
            reqdItem.length > 0 ? reqdItem[0].categoryId : null;
          if (reqdItem.length > 0) {
            let uom = uoms.filter((v) => v.value === reqdItem[0].stockUOMId);
            if (uom.length > 0) {
              x.uomId = uom[0].value;
              x.unit = uom[0].name;
            }
          }
        });

        dto.paymentTermsSupply = data.response.paymentTermsSupply;
        dto.paymentTermsInstallation = data.response.paymentTermsInstallation;

        setPaymentTerms({
          supplyTerms1: data.response.paymentTermsSupply.paymentTerm1Supply,
          supplyTerms2: data.response.paymentTermsSupply.paymentTerm2Supply,
          supplyTerms3: data.response.paymentTermsSupply.paymentTerm3Supply,
          supplyTerms4: data.response.paymentTermsSupply.paymentTerm4Supply,
          installationTerms1:
            data.response.paymentTermsInstallation.paymentTerm1Installation,
          installationTerms2:
            data.response.paymentTermsInstallation.paymentTerm2Installation,
          installationTerms3:
            data.response.paymentTermsInstallation.paymentTerm3Installation,
          installationTerms4:
            data.response.paymentTermsInstallation.paymentTerm4Installation,
        });

        setItemDetails((r) => [].concat(data.response.itemDetails));
        if (dto.isSummary === 0) {
          gridRef1.current.columnApi.setColumnsVisible(["item"], true);
        } else {
          gridRef1.current.columnApi.setColumnsVisible(["item"], false);
        }
        gridRef1.current.api.applyTransaction({
          add: data.response.itemDetails,
        });
        setTimeout(() => {
          let pinnedBottomData = generatePinnedBottomData();
          gridRef1.current.api.setPinnedBottomRowData([pinnedBottomData]);
        }, 2000);
      })
      .catch((e) => {
        setAlertTitleText("Oops", "An error occurred");
        setDataReady(true);
        return;
      });
  }

  const generatePinnedBottomData = () => {
    // generate a row-data with null values
    let result = {};

    gridRef1.current.columnApi.getAllGridColumns().forEach((item) => {
      result[item.colId] = null;
    });
    return calculatePinnedBottomData(result);
  };

  const calculatePinnedBottomData = (target) => {
    const computedColumns = [
      "supplyQty1",
      "supplyQty2",
      "supplyQty3",
      "supplyQty4",
      "installationQty1",
      "installationQty2",
      "installationQty3",
      "installationQty4",
      "supplyAmt1",
      "supplyAmt2",
      "supplyAmt3",
      "supplyAmt4",
      "installationAmt1",
      "installationAmt2",
      "installationAmt3",
      "installationAmt4",
    ];
    const columnsWithAggregation = [
      "paymentTerm1Supply",
      "paymentTerm2Supply",
      "paymentTerm3Supply",
      "paymentTerm4Supply",
      "paymentTerm1Installation",
      "paymentTerm2Installation",
      "paymentTerm3Installation",
      "paymentTerm4Installation",
      ...computedColumns,
    ];
    columnsWithAggregation.forEach((element) => {
      const allColumns = gridRef1.current.columnApi.getAllGridColumns();
      gridRef1.current.api.forEachNodeAfterFilter((rowNode) => {
        if (element === "itemCategory") {
          target[element] = "Grand Total";
          return;
        }
        if (rowNode.data[element] || rowNode.data[element] === 0)
          target[element] += Number.parseFloat(
            APIUTILS.Financial(rowNode.data[element])
          );
        if (computedColumns.indexOf(element) > -1) {
          target[element] += Number.parseFloat(
            APIUTILS.Financial(
              rowNode.beans.valueService.getValue(
                allColumns.filter((x) => x.colId === element)[0],
                rowNode
              )
            )
          );
        }
      });
      if (target[element]) {
        target[element] = `${APIUTILS.Financial(target[element])}`;
      }
    });
    return target;
  };

  const [dto, setDTO] = useState({
    siteCategoryId: 0,
    siteCategory: "",
    siteId: 0,
    site: "",
    salesOrderId: 0,
    salesOrderNo: "",
    raBillNo: 0,
    workOrderNo: 0,
    isSummary: 0,
    raBillDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    tillDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  });
  const [dataReady, setDataReady] = useState(false);
  const siteCategoryItems = getSiteCategories();
  const sites = getSites();
  const uoms = getUoms();
  const siteCategoryProps = {
    options: siteCategoryItems,
    getOptionLabel: (option) => option?.name || "",
  };
  const itemCategories = getItemCategories();
  const items = getItemList();
  const workorders = getOrders();
  const invoices = getInvoices();

  const siteProps = {
    options: sites,
    getOptionLabel: (option) => option?.name || "",
  };

  const workOrderProps = {
    options: workorders,
    getOptionLabel: (option) => option?.name || "",
  };

  const invoiceProps = {
    options: invoices,
    getOptionLabel: (option) => option?.name || "",
  };

  const [paymentTerms, setPaymentTerms] = useState({
    supplyTerms1: 0,
    supplyTerms2: 0,
    supplyTerms3: 0,
    supplyTerms4: 0,
    installationTerms1: 0,
    installationTerms2: 0,
    installationTerms3: 0,
    installationTerms4: 0,
    supplyQty1: 0,
    supplyQty2: 0,
    supplyQty3: 0,
    supplyQty4: 0,
    installationQty1: 0,
    installationQty2: 0,
    installationQty3: 0,
    installationQty4: 0,
    supplyAmt1: 0,
    supplyAmt2: 0,
    supplyAmt3: 0,
    supplyAmt4: 0,
    installationAmt1: 0,
    installationAmt2: 0,
    installationAmt3: 0,
    installationAmt4: 0,
  });
  // below code is for grid - 1
  const columnDefs1 = [
    {
      headerName: "WORK ORDER DETAILS",

      children: [
        {
          headerName: "",
          width: 400,
          children: [
            {
              flex: 2,
              headerName: "Parent Item",
              field: "parentItem",
              wrapText: true,
              autoHeight: true,
              cellStyle: {
                "border-right-color": "#e2e2e2",
              },
            },
            {
              flex: 2,
              headerName: "Item Name",
              field: "item",
              wrapText: true,
              autoHeight: true,
              hide: dto.isSummary !== 0,
              cellStyle: {
                "border-right-color": "#e2e2e2",
              },
            },
            {
              flex: 1.5,
              headerName: "Qty",
              field: "quantity",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "border-right-color": "#e2e2e2",
              },
            },
            {
              flex: 2,
              headerName: "Supply Rate",
              field: "supplyRate",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              flex: 2,
              headerName: "Inst Rate",
              field: "installationRate",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
          ],
        },
        {
          headerName: "Purchase Qty",
          children: [
            {
              flex: 1.5,
              headerName: "Stock Details",
              field: "purchaseQty",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
          ],
        },
      ],
    },
    {
      headerName: "SEPL BILLED QTY",

      children: [
        {
          headerName: "SUPPLY QTY",
          children: [
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms1}%`,
              field: "paymentTerm1Supply",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms2}%`,
              field: "paymentTerm2Supply",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms3}%`,
              field: "paymentTerm3Supply",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms4}%`,
              field: "paymentTerm4Supply",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
          ],
        },
        {
          headerName: "INST QTY",
          children: [
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms1}%`,
              field: "paymentTerm1Installation",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms2}%`,
              field: "paymentTerm2Installation",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms3}%`,
              field: "paymentTerm3Installation",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms4}%`,
              field: "paymentTerm4Installation",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
            },
          ],
        },
      ],
    },
    {
      headerName: "SEPL BALANCE QTY",
      children: [
        {
          headerName: "SUPPLY QTY",
          children: [
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms1}%`,
              field: "supplyQty1",
              filter: false,
              floatingFilter: false,

              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyQty1
                  ? params.data.supplyQty1
                  : params.data.purchaseQty - params.data.paymentTerm1Supply;
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms2}%`,
              field: "supplyQty2",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyQty2
                  ? params.data.supplyQty2
                  : params.data.purchaseQty - params.data.paymentTerm2Supply;
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms3}%`,
              field: "supplyQty3",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyQty3
                  ? params.data.supplyQty3
                  : params.data.purchaseQty - params.data.paymentTerm3Supply;
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms4}%`,
              field: "supplyQty4",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyQty4
                  ? params.data.supplyQty4
                  : params.data.purchaseQty - params.data.paymentTerm4Supply;
              },
            },
          ],
        },
        {
          headerName: "INST QTY",
          children: [
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms1}%`,
              field: "installationQty1",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationQty1
                  ? params.data.installationQty1
                  : params.data.purchaseQty -
                      params.data.paymentTerm1Installation;
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms2}%`,
              field: "installationQty2",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationQty2
                  ? params.data.installationQty2
                  : params.data.purchaseQty -
                      params.data.paymentTerm2Installation;
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms3}%`,
              field: "installationQty3",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationQty3
                  ? params.data.installationQty3
                  : params.data.purchaseQty -
                      params.data.paymentTerm3Installation;
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms4}%`,
              field: "installationQty4",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationQty4
                  ? params.data.installationQty4
                  : params.data.purchaseQty -
                      params.data.paymentTerm4Installation;
              },
            },
          ],
        },
      ],
    },
    {
      headerName: "SEPL BALANCE AMOUNT",
      children: [
        {
          headerName: "SUPPLY AMOUNT",
          children: [
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms1}%`,
              field: "supplyAmt1",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyAmt1
                  ? params.data.supplyAmt1
                  : (params.data.purchaseQty - params.data.paymentTerm1Supply) *
                      (paymentTerms.supplyTerms1 / 100) *
                      params.data.supplyRate;
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms2}%`,
              field: "supplyAmt2",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyAmt2
                  ? params.data.supplyAmt2
                  : (params.data.purchaseQty - params.data.paymentTerm2Supply) *
                      (paymentTerms.supplyTerms2 / 100) *
                      params.data.supplyRate;
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms3}%`,
              field: "supplyAmt3",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyAmt3
                  ? params.data.supplyAmt3
                  : (params.data.purchaseQty - params.data.paymentTerm3Supply) *
                      (paymentTerms.supplyTerms3 / 100) *
                      params.data.supplyRate;
              },
            },
            {
              headerValueGetter: (params) => `${paymentTerms.supplyTerms4}%`,
              field: "supplyAmt4",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.supplyAmt4
                  ? params.data.supplyAmt4
                  : (params.data.purchaseQty - params.data.paymentTerm4Supply) *
                      (paymentTerms.supplyTerms4 / 100) *
                      params.data.supplyRate;
              },
            },
          ],
        },
        {
          headerName: "INST AMOUNT",
          children: [
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms1}%`,
              field: "installationAmt1",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              //installationRate
              valueGetter: (params) => {
                return params.data.installationAmt1
                  ? params.data.installationAmt1
                  : (params.data.purchaseQty -
                      params.data.paymentTerm1Installation) *
                      (paymentTerms.installationTerms1 / 100) *
                      params.data.installationRate;
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms2}%`,
              field: "installationAmt2",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationAmt2
                  ? params.data.installationAmt2
                  : (params.data.purchaseQty -
                      params.data.paymentTerm2Installation) *
                      (paymentTerms.installationTerms2 / 100) *
                      params.data.installationRate;
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms3}%`,
              field: "installationAmt3",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationAmt3
                  ? params.data.installationAmt3
                  : (params.data.purchaseQty -
                      params.data.paymentTerm3Installation) *
                      (paymentTerms.installationTerms3 / 100) *
                      params.data.installationRate;
              },
            },
            {
              headerValueGetter: (params) =>
                `${paymentTerms.installationTerms4}%`,
              field: "installationAmt4",
              filter: false,
              floatingFilter: false,
              cellStyle: {
                "text-align": "center",
                "border-right-color": "#e2e2e2",
              },
              valueGetter: (params) => {
                return params.data.installationAmt4
                  ? params.data.installationAmt4
                  : (params.data.purchaseQty -
                      params.data.paymentTerm4Installation) *
                      (paymentTerms.installationTerms4 / 100) *
                      params.data.installationRate;
              },
            },
          ],
        },
      ],
    },
  ];
  const gridRef1 = useRef();
  const defaultColDef1 = {
    resizable: true,
    sortable: true,
    editable: false,
    flex: 1,
    filter: "agTextColumnFilter",
    filterParams: {
      caseSensitive: false,
      defaultOption: "startsWith",
    },
    floatingFilter: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };
  const onGridReady1 = (params) => {
    const p2 = APIMASTER.SiteCategories()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setSiteCategories(resp.response);
      });

    const p4 = APIMASTER.SiteOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setSites(resp.response);
      });

    const p5 = APISALES.SalesOrderOptions("all")
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setOrders(resp.response);
      });

    const p6 = APIMASTER.InvoiceOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setInvoices(resp.response);
      });

    const p7 = APIMASTER.UomOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setUoms(resp.response);
      });

    Promise.all([p2, p4, p5, p6, p7]).then(() => {
      try {
        setDataReady(true);
        gridRef1.current.api.setRowData([]);
      } catch (e) {}
    });
  };
  const [selectedRowId1, setSelectedRowId1] = useState(0);

  const onRowSelectionChanged1 = (event) => {
    if (event.api.getSelectedRows().length > 0)
      setSelectedRowId1(event.api.getSelectedRows()[0].id);
    else setSelectedRowId1(0);
  };
  // grid 1 code ends

  const supplierCategories = getSupplierCategories().filter((x) => {
    return x.dependentvalue === "L";
  });
  const suppliers = getSuppliers().filter((x) => {
    return (
      supplierCategories.filter((y) => y.value === x.dependentvalue).length > 0
    );
  });

  const supplierProps = {
    options: suppliers,
    getOptionLabel: (option) => option?.name || "",
  };
  return (
    <SideNav
      currentComponent={CUSTOMER_MANAGEMENT_REPORT}
      subComponent={BALANCE_BILLING_REPORT}
      subComponentPath={PATH_BALANCE_BILLING_REPORT}
      detailComponent=""
    >
      <div>
        <div style={style}>
          <ThreeCircles
            visible={!dataReady}
            height="256"
            width="256"
            outerCircleColor={SPANISH_GREEN}
            innerCircleColor="#eeeeee"
            middleCircleColor={SPANISH_GREEN}
            ariaLabel="eNirmaan-loading"
            color={SPANISH_GREEN}
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
        <form>
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              marginBottom: 10,
              marginRight: 10,
            }}
          >
            <Button
              style={{
                backgroundColor: SPANISH_GREEN,
                textTransform: "capitalize",
                fontSize: 14,
                color: WHITE,
                minWidth: "180px",
                minHeight: "45px",
                marginRight: 10,
              }}
              onClick={onFormSubmit}
            >
              {GENERATE}
            </Button>
            <Button
              variant="outlined"
              sx={{
                borderColor: SPANISH_GREEN,
              }}
              style={{
                //backgroundColor: SPANISH_GREEN,
                textTransform: "capitalize",
                fontSize: 14,
                color: SPANISH_GREEN,
                minWidth: "180px",
                minHeight: "45px",
                marginRight: 10,
              }}
              onClick={() => {
                let filename = "";
                const sortedItemDetails = getSortedDataFromGrid();
                dto.itemDetails = sortedItemDetails;
                setDataReady(false);
                APIREPORTS.BalanceBillingReportExport(dto)
                  .then((res) => {
                    setDataReady(true);

                    const contentType = res.headers.get("content-type");
                    if (contentType.startsWith("application/json")) {
                      return Promise.reject(res.json());
                    } else {
                      const header = res.headers.get("Content-Disposition");
                      if (header !== null) {
                        const parts = header.split(";");
                        filename = parts[1].split("=")[1].replaceAll('"', "");
                      } else {
                        filename = "Balance Billing Export Report.xlsx";
                      }

                      return res.blob();
                    }
                  })
                  .then((blob) => {
                    if (blob !== null) {
                      let url = window.URL.createObjectURL(blob);
                      let a = document.createElement("a");
                      a.href = url;
                      a.download = filename;
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                    }
                  })
                  .catch((m) => {
                    setAlertTitleText(
                      "Oops...",
                      `Something went wrong...${m.message}`
                    );
                  });
              }}
            >
              {EXPORT}
            </Button>
          </div>
          {/* button div ends */}
          {/* below code is for above container */}
          <div
            style={{
              backgroundColor: LIGHT_GREY_BACKGROUND,
              borderRadius: "5px",
              minWidth: "90%",
              minHeight: "50px",
              padding: 20,
              marginBottom: 10,
              borderStyle: "solid",
              border: "1x",
              borderColor: "#eaeaea",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <table style={{ width: "100%" }}>
              <TableBody>
                <tr>
                  <td>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="RA Bill Date"
                        inputFormat="DD-MM-YYYY"
                        style={{ minWidth: "272px", minHeight: "48.5px" }}
                        value={dto.raBillDate}
                        onChange={(newValue) => {
                          setDTO({
                            ...dto,
                            raBillDate: newValue.format("YYYY-MM-DD"),
                            tillDate: dayjs(newValue).endOf("month"),
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            variant="standard"
                            required
                            {...params}
                            style={{
                              minWidth: "350px",
                              minHeight: "48.5px",
                              width: "200px",
                            }}
                            InputLabelProps={{
                              style: { color: "grey", fontSize: 14 },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              style: { fontSize: 14 },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </td>

                  <td>
                    <Autocomplete
                      filterOptions={globalFilter}
                      {...siteCategoryProps}
                      options={siteCategoryItems}
                      id="auto-complete-1"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="siteCategoryId"
                      defaultValue={
                        siteCategoryProps.options.find(
                          (v) => v.value === dto.siteCategoryId
                        ) || {}
                      }
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({
                              ...dto,
                              siteCategoryId: v?.value,
                              siteCategory: v?.name,
                            });
                          else
                            setDTO({
                              ...dto,
                              siteCategoryId: Number(v?.value),
                              siteCategory: v?.name,
                            });
                        } else {
                          setDTO({
                            ...dto,
                            siteCategoryId: v?.value,
                            siteCategory: v?.name,
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Site Category"
                          required
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            width: "200px",
                            minHeight: "48.5px",
                            height: "48.5px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey" },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <Autocomplete
                      {...siteProps}
                      id="auto-complete-2"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="siteId"
                      defaultValue={
                        siteProps.options.find((v) => v.value === dto.siteId) ||
                        {}
                      }
                      filterOptions={(o, s) => {
                        let options = globalFilter(o, s);
                        let newOptions = [];
                        options.forEach((element) => {
                          if (element.dependentvalue === dto.siteCategoryId)
                            newOptions.push(element);
                        });
                        return newOptions;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, siteId: v?.value, site: v?.name });
                          else
                            setDTO({
                              ...dto,
                              siteId: Number(v?.value),
                              site: v?.name,
                            });
                        } else {
                          setDTO({ ...dto, siteId: v?.value, site: v?.name });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Site"
                          required
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "48.5px",
                            width: "200px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Autocomplete
                      {...workOrderProps}
                      id="auto-complete-3"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="workOrderNo"
                      defaultValue={
                        workOrderProps.options.find(
                          (v) => v.value === dto.workOrderNo
                        ) || {}
                      }
                      filterOptions={(o, s) => {
                        let options = globalFilter(o, s);
                        let newOptions = [];
                        options.forEach((element) => {
                          if (element.dependentvalue === dto.siteId)
                            newOptions.push(element);
                        });
                        return newOptions;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({
                              ...dto,
                              workOrderNo: v?.value,
                              salesOrderId: v?.value,
                              salesOrderNo: v?.name,
                            });
                          else
                            setDTO({
                              ...dto,
                              workOrderNo: Number(v?.value),
                              salesOrderId: v?.value,
                              salesOrderNo: v?.name,
                            });
                        } else {
                          setDTO({
                            ...dto,
                            workOrderNo: v?.value,
                            salesOrderId: v?.value,
                            salesOrderNo: v?.name,
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Work Order No"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "48.5px",
                            width: "200px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <Autocomplete
                      {...invoiceProps}
                      id="auto-complete-4"
                      autoComplete
                      autoHighlight
                      autoSelect
                      includeInputInList
                      name="raBillNo"
                      defaultValue={
                        invoiceProps.options.find(
                          (v) => v.value === dto.raBillNo
                        ) || {}
                      }
                      filterOptions={(o, s) => {
                        let options = globalFilter(o, s);
                        let newOptions = [];
                        options.forEach((element) => {
                          if (element.dependentvalue === dto.siteId)
                            newOptions.push(element);
                        });
                        return newOptions;
                      }}
                      onChange={(e, v) => {
                        if (v) {
                          if (isNaN(v?.value))
                            setDTO({ ...dto, raBillNo: v?.value });
                          else setDTO({ ...dto, raBillNo: Number(v?.value) });
                        } else {
                          setDTO({ ...dto, raBillNo: v?.value });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="RA Bill No"
                          variant="standard"
                          multiline
                          maxRows={3}
                          style={{
                            minWidth: "350px",
                            minHeight: "48.5px",
                            width: "200px",
                          }}
                          InputLabelProps={{
                            style: { color: "grey", fontSize: 14 },
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { fontSize: 14 },
                          }}
                        />
                      )}
                    />
                  </td>
                  <td>
                    <FormControlLabel
                      name="isSummary"
                      style={{ userSelect: "none" }}
                      control={<Checkbox size="small" color="success" />}
                      onChange={(e, v) =>
                        setDTO({
                          ...dto,
                          isSummary: e.target.checked ? 1 : 0,
                        })
                      }
                      checked={dto.isSummary !== 0}
                      label="Is Summary"
                    />
                  </td>
                </tr>
              </TableBody>
            </table>
          </div>
        </form>
      </div>
      <div
        style={{
          //display:"flex",
          scrollbarWidth: "",
          overflowX: "auto",
          width: "100%",
        }}
      >
        {/* below code is for ag-grid -1 */}
        <div className="App">
          <div
            className="ag-theme-alpine"
            style={{ height: "570px", width: "2600px" }}
          >
            <AgGridReact
              copyGroupHeadersToClipboard={true}
              enableRangeSelection={true}
              columnDefs={columnDefs1}
              ref={gridRef1}
              defaultColDef={defaultColDef1}
              onGridReady={onGridReady1}
              pagination={false}
              onSelectionChanged={onRowSelectionChanged1}
            ></AgGridReact>
          </div>
        </div>
      </div>
    </SideNav>
  );
}
//how to add static pinned row with total in ag-grid react?
